import * as React from "react";

import { toNumber } from "../helpers";

import { IdleHandler } from "./idleHandler";

const INACTIVITY_TIMEOUT =
  (window as unknown as { _INACTIVITY_TIMEOUT: string | undefined })._INACTIVITY_TIMEOUT ??
  process.env.REACT_APP_DASHBOARD_INACTIVITY_TIMEOUT ??
  15 * 60 * 1000;
const INACTIVITY_CHECK_INTERVAL =
  (window as unknown as { _INACTIVITY_CHECK_INTERVAL: string | undefined })._INACTIVITY_CHECK_INTERVAL ??
  process.env.REACT_APP_DASHBOARD_INACTIVITY_CHECK_INTERVAL ??
  10000;

const timeout = toNumber(INACTIVITY_TIMEOUT) ?? 0;
const interval = toNumber(INACTIVITY_CHECK_INTERVAL) ?? 10000;

export const UserInactivityHandler: React.FC<{ onIdle: () => void }> = ({ onIdle: handleIdle }) => {
  return <IdleHandler onIdle={handleIdle} timeout={timeout} interval={interval} />;
};
